import { useEffect, useRef, useState } from "react";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

export function useHeroScrollParallax() {
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const reducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (reducedMotion) {
      setScrollProgress(0);
      return;
    }

    let ticking = false;

    const update = () => {
      ticking = false;
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const h = Math.max(rect.height, 1);
      const vh = typeof window !== "undefined" ? window.innerHeight : 800;

      const start = 0;
      const scrolled = -rect.top;
      const travel = Math.max(0, scrolled - start);
      const denom = Math.max(h * 0.92 + vh * 0.08, 1);
      const p = Math.min(1, Math.max(0, travel / denom));
      setScrollProgress(p);
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [reducedMotion]);

  return { sectionRef, scrollProgress: reducedMotion ? 0 : scrollProgress };
}
